<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="card mb-5 mb-xl-8">
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold fs-3 mb-1">{{
              "conclusionOptions" | translate
            }}</span>
          </h3>
        </div>
        <div class="card-body pt-3 pb-6">
          <div class="d-flex align-items-center justify-content-between mb-6">
            <!-- Filters -->
            <div
              class="btn-group"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <div *ngFor="let application of applications; let i = index">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio{{ i }}"
                  autocomplete="off"
                  [checked]="application.code === selectedApplicationCode"
                />
                <label
                  (click)="selectApplicationFilter(application.code)"
                  class="btn btn-sm btn-outline-dark cursor-pointer"
                  for="btnradio{{ i }}"
                  >{{ application.title }}</label
                >
              </div>
            </div>

            <div class="d-flex align-items-center gap-6">
              <!-- Language Selection -->
              <div class="form-group">
                <select
                  id="languageSelect"
                  class="form-select form-select-sm"
                  [(ngModel)]="selectedLanguage"
                >
                  <option *ngFor="let lang of languages" [value]="lang.code">
                    {{ lang.name }}
                  </option>
                </select>
              </div>

              <!-- Create new option btn -->
              <div class="d-flex justify-content-end">
                <a
                  [routerLink]="[
                    '/conclusion-options/create',
                    selectedApplicationCode
                  ]"
                  selectedApplicationCode
                  class="btn btn-sm fw-bold btn-primary"
                  >{{ "createNewOption" | translate }}</a
                >
              </div>
            </div>
          </div>
          <div
            *ngIf="optionListLoading; else optionList"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden">userListLoading...</span>
            </div>
          </div>
          <!-- Option list -->
          <ng-template #optionList>
            <div
              *ngIf="conclusionOptions?.length; else noConclusionOptions"
              class="accordion shadow-sm"
              id="accordionExample"
            >
              <div
                *ngFor="
                  let conclusionOption of conclusionOptions;
                  let i = index
                "
                class="accordion-item"
              >
                <h2 class="accordion-header cursor-pointer">
                  <button
                    class="accordion-button text-dark"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse' + i"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapse' + i"
                  >
                    <div class="d-flex align-items-center gap-4">
                      <ng-container *ngFor="let lang of languages">
                        <div *ngIf="selectedLanguage === lang.code">
                          <strong>
                            {{ "optionTitle" | translate }} ({{ lang.name }}):
                          </strong>
                          {{ conclusionOption["title" + lang.query] || "-" }}
                        </div>
                      </ng-container>
                    </div>
                  </button>
                </h2>
                <div
                  [attr.id]="'collapse' + i"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <!-- Add option -->
                  <div class="d-flex justify-content-start my-4 ps-5">
                    <a
                      [routerLink]="[
                        '/conclusion-options/add',
                        selectedApplicationCode,
                        conclusionOption.conclusionOptionContents[0]
                          .conclusionOptionId
                      ]"
                      class="btn btn-sm btn-primary"
                      >{{ "addNewOption" | translate }}</a
                    >
                  </div>
                  <div class="accordion-body">
                    <div
                      *ngFor="
                        let content of conclusionOption.conclusionOptionContents;
                        let isLast = last
                      "
                    >
                      <div
                        class="accordion-wrapper d-flex justify-content-between align-items-center option-title"
                      >
                        <div class="accordion-wrapper-left flex-grow-1">
                          <ng-container *ngFor="let lang of languages">
                            <p
                              *ngIf="selectedLanguage === lang.code"
                              class="my-0"
                            >
                              <strong>
                                {{ "optionTitle" | translate }} ({{
                                  lang.name
                                }}):
                              </strong>
                              {{ content?.['title' + lang.query] || "-" }}
                            </p>
                          </ng-container>
                        </div>
                        <!-- Actions -->
                        <div class="accordion-wrapper-right">
                          <a
                            [routerLink]="[
                              '/conclusion-options/edit',
                              content?.id
                            ]"
                            class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm cursor-pointer"
                            title="{{ 'edit' | translate }}"
                            ><i class="fa-regular fa-pen-to-square"></i
                          ></a>
                          <a
                            (click)="deleteModalId = content?.id || ''"
                            data-bs-toggle="modal"
                            [attr.data-bs-target]="
                              '#optionDeleteModal-' + deleteModalId
                            "
                            title="{{ 'delete' | translate }}"
                            class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm cursor-pointer"
                            ><i class="fa-regular fa-trash-can"></i
                          ></a>
                        </div>
                      </div>
                      <div class="px-3">
                        <div class="mt-3">
                          <ng-container *ngFor="let lang of languages">
                            <p *ngIf="selectedLanguage === lang.code">
                              <strong
                                >{{ "conclusionText" | translate }} ({{
                                  lang.name
                                }}):
                              </strong>
                              {{ content?.['conclusionText' + lang.query] || "-" }}
                            </p>
                          </ng-container>
                        </div>
                      </div>
                      <hr *ngIf="!isLast" class="mt-0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noConclusionOptions>
              <div class="pt-4 px-8 text-center">
                <p class="fs-5">
                  {{ "noConclusionOptionsAvailableToBeDisplayed" | translate }}
                </p>
              </div>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Conclusion Option Modal -->
<div
  class="modal fade"
  [id]="'optionDeleteModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="optionDeleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="optionDeleteModalLabel">
          {{ "deleteOption" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "deleteOptionModal" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          (click)="deleteConclusionOptionContent(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
